import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 20h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 20v-4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SignalLow";
const SignalLow = memo(themed(Icon));
export {
  SignalLow
};
//# sourceMappingURL=signal-low.js.map
